import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ReactiveFormsModule, FormControl } from '@angular/forms';
import { DatePickerModule } from 'primeng/datepicker';
import { FIELD_CONTROL, FIELD_CONFIG } from './field-tokens';

@Component({
  selector: 'app-field-datetime',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ReactiveFormsModule, DatePickerModule],
  template: `
    <p-datepicker [formControl]="formControl"
      [showTime]="true" [showIcon]="true" iconDisplay="input"
      [placeholder]="config.placeholder || 'Select date & time'"
      appendTo="body" class="w-full" fluid />
  `
})
export class DatetimeFieldComponent {
  readonly config  = inject(FIELD_CONFIG);
  readonly control = inject(FIELD_CONTROL);
  get formControl(): FormControl { return this.control as FormControl; }
}
